import { BuildMode } from 'src/environments/environment.base';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

export function getSidebarItems(
    pendingChangesCount?: number,
    isOriginWorkspace?: boolean,
    isLoading?: boolean,
    isExpanded?: boolean,
    isReadOnlyUser?: boolean,
    currentDB?: string
): MenuItem[] {
    return [
        {
            label: 'Tools',
            icon: 'pi pi-wrench',
            badge:
                !isExpanded && isOriginWorkspace === false
                    ? isLoading
                        ? undefined
                        : pendingChangesCount?.toString()
                    : undefined,
            isLoading: isLoading,
            items: [
                {
                    label: 'Pending Changes',
                    icon: 'pi pi-clock',
                    routerLink: '/pending-changes',
                    badge:
                        isOriginWorkspace === false
                            ? isLoading
                                ? undefined
                                : (pendingChangesCount ?? 0).toString()
                            : undefined,
                    isLoading: isLoading,
                    showDisabledChip: isOriginWorkspace === true,
                },
                {
                    label: 'Reports',
                    icon: 'pi pi-file-export',
                    routerLink: '/reports',
                },
                ...(!isReadOnlyUser
                    ? [
                          {
                              label: 'Structure Release Report',
                              icon: 'pi pi-file-check',
                              routerLink: '/structure-release-report',
                          },
                          {
                              label: 'Scania Lexicon Import',
                              icon: 'pi pi-upload',
                              routerLink: '/lexicon-import',
                          },
                      ]
                    : []),
                {
                    label: `Change database. Current: ${currentDB}`,
                    icon: 'pi pi-database',
                    visible: environment.buildMode !== BuildMode.PRODUCTION,
                    routerLink: '/current-db',
                },
                {
                    label: 'About & Support',
                    icon: 'pi pi-question-circle',
                    routerLink: '/about',
                },
            ],
        },
    ];
}
